import api from "./api/config";

export const productService = {
  // Belirli bir kategorinin ürünlerini getir
  getProductsByCategory: async (categoryId) => {
    if (!categoryId) {
      throw new Error("Kategori ID'si gereklidir.");
    }
    try {
      const params = { category_id: categoryId };
      console.log("ProductService: Ürünler isteniyor, params:", params);
      const response = await api.get("/products/list", { params });
      console.log("ProductService: Ürünler yanıtı:", response);

      // API'den dönen verinin doğrudan data kısmını dönelim
      return response.data || [];
    } catch (error) {
      console.error("ProductService Error fetching products:", error);
      throw new Error("Ürünler getirilirken bir hata oluştu.");
    }
  },

  // Belirli bir ürün için bayi fiyatlarını getir
  getDealerPricesForProduct: async (productId, districtId) => {
    // districtId'nin null veya geçerli bir ID olabileceğini varsayıyoruz
    if (!productId) {
      throw new Error("Ürün ID'si gereklidir.");
    }
    try {
      const params = { productId };
      if (districtId) {
        params.districtId = districtId;
      } else {
        // districtId yoksa ne yapılmalı? API tüm ilçeleri mi getiriyor?
        // Şimdilik districtId yoksa istek atmayalım veya API dokümanına göre hareket edelim.
        // VEYA: districtId yoksa null göndermeyi deneyebiliriz, API'nin nasıl davrandığına bağlı.
        // params.districtId = null;
        console.log("getDealerPricesForProduct: districtId belirtilmedi.");
        // Hata fırlatmak yerine boş dizi döndürebiliriz, hook bunu yönetir.
        return [];
      }

      console.log("ProductService: Bayi fiyatları isteniyor, params:", params);
      const response = await api.get("/dealers/getDealerPricesByProduct", {
        params,
      });
      console.log("ProductService: Bayi fiyatları yanıtı:", response);

      // Yanıt yapısını kontrol edelim ({ status: 1, data: [...] } varsayımı)
      if (response && response.status === 1 && Array.isArray(response.data)) {
        return response.data; // Bayi/fiyat dizisini dön
      }

      console.warn(
        "Beklenmeyen bayi fiyatları yanıtı yapısı veya status!=1:",
        response
      );
      return []; // Hata veya beklenmeyen yanıtta boş dizi dön
    } catch (error) {
      console.error("ProductService Error fetching dealer prices:", error);
      // Hata detayını fırlatmak yerine daha kullanıcı dostu mesaj olabilir
      throw new Error("Bayi fiyatları getirilirken bir hata oluştu.");
    }
  },

  // Belirli bir ürünü ID ile getir (Yeniden aktif edildi ve düzeltildi)
  getProductById: async (productId) => {
    if (!productId) {
      throw new Error("Ürün ID'si gereklidir.");
    }
    try {
      // Göreceli yol
      const params = { productId: productId };
      const response = await api.get("/products/getProduct", { params });
      console.log("ProductService: Ürün detayı yanıtı:", response);

      // Yanıt yapısını kontrol edelim ({ status: 1, data: {...} } varsayımı)
      if (response && response.status === 1 && response.data) {
        return response.data; // Ürün detay objesini dön
      }

      console.warn(
        "Beklenmeyen ürün detayı yanıtı yapısı veya status!=1:",
        response
      );
      return null;
    } catch (error) {
      console.error("ProductService Error fetching product detail:", error);
      throw new Error("Ürün detayı getirilirken bir hata oluştu.");
    }
  },

  // Belirli bir bayinin ürün/fiyat listesini getir
  getDealerProducts: async (dealerId) => {
    if (!dealerId) {
      throw new Error("Bayi ID'si gereklidir.");
    }
    try {
      const params = { dealerId };
      console.log(
        "ProductService: Bayi ürün/fiyatları isteniyor, params:",
        params
      );
      // Token interceptor tarafından eklenecek
      const response = await api.get("/dealers/getDealerPrices", {
        params,
      });
      console.log("ProductService: Bayi ürün/fiyatları yanıtı:", response);

      // Yanıt yapısını kontrol edelim ({ status: 1, data: [...] } varsayımı)
      if (response && response.status === 1 && Array.isArray(response.data)) {
        return response.data;
      }
      // Doğrudan dizi dönme ihtimali?
      // if (Array.isArray(response)) { return response; }

      console.warn(
        "Beklenmeyen bayi ürün/fiyat yanıtı yapısı veya status!=1:",
        response
      );
      return []; // Hata veya beklenmeyen yanıtta boş dizi dön
    } catch (error) {
      console.error(
        "ProductService Error fetching dealer products/prices:",
        error
      );
      throw new Error("Bayi ürün ve fiyatları getirilirken bir hata oluştu.");
    }
  },
};

export default productService;
